// src/mainframes/sidebar/CalendarPopupListener.jsx
import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Box, Typography } from "@mui/material";

export default function CalendarPopupListener() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      console.log("📅 CalendarPopupListener received event:", e.detail);
      
      const payload = e.detail || {};
      const event = payload.event || payload;
      
      setData(event || null);
      setOpen(true);
    };

    window.addEventListener("calendar-popup", handler);
    return () => window.removeEventListener("calendar-popup", handler);
  }, []);

  const handleClose = () => {
    setOpen(false);
    // Optional: clear data after close animation
    setTimeout(() => setData(null), 300);
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth="xs" 
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 900, bgcolor: "primary.main", color: "white" }}>
        📅 {data?.title || "Reminder"}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 16 }}>
          {data?.message || "You have a scheduled reminder"}
        </Typography>

        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 2 }}>
          Recurrence: {data?.recurrence || "N/A"}
        </Typography>

        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={handleClose} variant="contained">
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}